import { Redirect } from "react-router-dom"
import Authentication from "../../Store/Authentication/AuthenticationStore"

const HomePage: React.FC = () => {
    return (
        Authentication.isAdminAuthenticated() ? <Redirect to={{ pathname: "/subjects"}} /> :
        Authentication.isAdjudicatorAuthenticated() ? <Redirect to={{ pathname: "/adjudication"}} /> :
        <Redirect to={{ pathname: "/login"}} />
    )
}

export default HomePage